import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import '../styles/Login.css';

function ResetPassword() {
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [sessionReady, setSessionReady] = useState(false);

    useEffect(() => {
        // Supabase automatically handles the token from the URL hash
        // and establishes a session when the user clicks the reset link.
        // We listen for the PASSWORD_RECOVERY event to know we're ready.
        const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
            if (event === 'PASSWORD_RECOVERY') {
                setSessionReady(true);
            }
            // Also handle if the user already has a valid session (e.g. page refresh)
            if (session && !sessionReady) {
                setSessionReady(true);
            }
        });

        // Check if there's already a session
        supabase.auth.getSession().then(({ data: { session } }) => {
            if (session) {
                setSessionReady(true);
            }
        });

        return () => subscription.unsubscribe();
    }, [sessionReady]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (password !== confirmPassword) {
            setError('Les mots de passe ne correspondent pas.');
            return;
        }

        if (password.length < 6) {
            setError('Le mot de passe doit contenir au moins 6 caractères.');
            return;
        }

        setLoading(true);

        try {
            const { error } = await supabase.auth.updateUser({
                password: password
            });

            if (error) throw error;

            setSuccess(true);

            // Redirect to login after 3 seconds
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (err) {
            setError(err.message || 'Erreur lors de la mise à jour du mot de passe');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h1>ENOVADENT</h1>
                    <p>Nouveau mot de passe</p>
                </div>

                {success ? (
                    <div className="login-form">
                        <div className="forgot-success-container">
                            <div className="forgot-success-icon">✅</div>
                            <h2 className="forgot-success-title">Mot de passe mis à jour !</h2>
                            <p className="forgot-success-text">
                                Votre mot de passe a été modifié avec succès.
                                Vous allez être redirigé vers la page de connexion...
                            </p>
                        </div>
                    </div>
                ) : !sessionReady ? (
                    <div className="login-form">
                        <div className="forgot-success-container">
                            <div className="forgot-success-icon" style={{ animation: 'spin 1s linear infinite' }}>⏳</div>
                            <h2 className="forgot-success-title">Vérification en cours...</h2>
                            <p className="forgot-success-text">
                                Nous vérifions votre lien de réinitialisation. Si cette page ne change pas, le lien est peut-être expiré ou invalide.
                            </p>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="login-form">
                        <p className="forgot-instructions">
                            Choisissez un nouveau mot de passe pour votre compte.
                        </p>

                        <div className="form-group">
                            <label>Nouveau mot de passe</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="••••••••"
                                minLength={6}
                                autoComplete="new-password"
                                autoFocus
                            />
                        </div>

                        <div className="form-group">
                            <label>Confirmer le mot de passe</label>
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                placeholder="••••••••"
                                minLength={6}
                                autoComplete="new-password"
                            />
                        </div>

                        {error && (
                            <div className="message error">
                                {error}
                            </div>
                        )}

                        <button type="submit" className="submit-btn" disabled={loading}>
                            {loading ? 'Mise à jour...' : 'Réinitialiser le mot de passe'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}

export default ResetPassword;
